// extracted by mini-css-extract-plugin
export default {"get":"Get_get__fjt1W","getBody":"Get_getBody__xS54o","getTitle":"Get_getTitle__LrBuA","getSubtitle":"Get_getSubtitle__b9Fx3","getTryBtn":"Get_getTryBtn__Pe4Fj"};